// src/Dashboard.jsx
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getStudentIdFromToken } from "./utils/auth";
import "./Dashboard.css";
import pitlabsLogo from "./assets/PITlogo.png";

const backgroundStyle = {
  background: "url('/background.png') center/cover no-repeat",
  minHeight: "100vh"
};

const TABS = [
  { key: "available", label: "Available Projects" },
  { key: "bidded", label: "Bidded Projects" },
  { key: "completed", label: "Completed Projects" },
  { key: "ongoing", label: "Ongoing Projects" },
];

function Dashboard() {
  const [projects, setProjects] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [bidAmounts, setBidAmounts] = useState({});
  const [activeTab, setActiveTab] = useState("available");
  const navigate = useNavigate();
  const student_id = getStudentIdFromToken();

  useEffect(() => {
    const fetchProjects = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Unauthorized! Please log in.");
        navigate("/login");
        return;
      }

      try {
        const response = await fetch("http://localhost:5002/dashboardrouter/dashboard", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          alert("Session expired. Please log in again.");
          localStorage.removeItem("token");
          navigate("/login");
          return;
        }

        const data = await response.json();
        setProjects(data);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };

    fetchProjects();
  }, [navigate]);

  const handleBid = async (projectId) => {
    const bidAmount = bidAmounts[projectId];
    if (!bidAmount) {
      alert("Please enter a bid amount.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch("http://localhost:5002/student/bid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          project_id: projectId,
          student_id: student_id,
          bid_amount: bidAmount,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        alert("Bid submitted successfully!");

        const biddedProject = projects.available.find((p) => p.project_id === projectId);
        setProjects((prev) => ({
          ...prev,
          available: prev.available.filter((p) => p.project_id !== projectId),
          bidded: [...(prev.bidded || []), { ...biddedProject, bid_amount: bidAmount }],
        }));

        setBidAmounts((prev) => {
          const updated = { ...prev };
          delete updated[projectId];
          return updated;
        });
      } else {
        alert(data.error || "Failed to submit bid.");
      }
    } catch (error) {
      console.error("Bid submission failed:", error);
    }
  };

  const filterProjects = (list = []) =>
    list.filter((project) =>
      project.project_title.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const renderTabs = () => (
    <div className="tabs">
      {TABS.map(({ key, label }) => (
        <button
          key={key}
          className={`tab-btn ${activeTab === key ? "active" : ""}`}
          onClick={() => setActiveTab(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );

  const renderProjects = (projectsList = []) => (
    <div className="project-list">
      {filterProjects(projectsList).map((project) => (
        <div className="project-card" key={project.project_id}>
          <div className="project-title">{project.project_title}</div>
          <div className="project-actions">
            <button
              onClick={() => navigate(`/project/${project.project_id}`)}
              className="desc-btn"
            >
              view desc
            </button>
            {activeTab === "available" && (
              <>
                <input
                  type="number"
                  placeholder="Enter bid amount"
                  value={bidAmounts[project.project_id] || ""}
                  onChange={(e) =>
                    setBidAmounts({
                      ...bidAmounts,
                      [project.project_id]: e.target.value,
                    })
                  }
                  className="bid-input"
                />
                <button
                  onClick={() => handleBid(project.project_id)}
                  className="bid-btn"
                >
                  bid
                </button>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/login");
  };

  return (
    <div className="dashboard" style={backgroundStyle}>
      <header className="navbar">
        <img src={pitlabsLogo} alt="PIT Labs Logo" className="logo-img" />
        <nav>
          <Link to="#">Project</Link>
          <Link to="#">Account</Link>
          <button onClick={logout}>Log Out</button>
        </nav>
      </header>

      <h2 className="section-title">PROJECTS</h2>
      <input
        type="text"
        placeholder="Search projects..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />
      {renderTabs()}
      {renderProjects(projects[activeTab])}
    </div>
  );
}

export default Dashboard;
